export default "__VITE_ASSET__DOu74rQe__"